import React from 'react'
import "../../App.css";
import { Link } from 'react-router-dom';

const Succesfull = () => {
    // Generate a random reference number with prefix "RN"
    const result = "RN" + Math.floor(Math.random() * (40000000 - 0 + 1)) + 0;
    
    return (
    <div>
          <div className="container marg-wrapp success_container">
              <div className="row container succes">
                  <div className="col-lg-12">
                      <div className="succes-image">
                          <img src="assets/images/Buy Step 9@2x (1).png" width="266px" height="178px" alt="Success" />
                      </div>
                  </div>
                  <div className="col-lg-12">
                      <div className="succes-text">
                          Your request no <span className="text-danger">({result}) </span> has been submitted successfully!
                      </div>
                  </div>
                  <div className="col-lg-12">
                      <div className="succes-p">
                          Thank you for submitting your car details. Our team will review your information 
                          and contact you shortly to proceed with the next steps. Please save your reference 
                          number for future correspondence.
                      </div>
                  </div>
                  <div className="col-lg-12">
                      <div className="d-flex justify-content-center mt-4">
                          <Link className="btn-text me-3" to="/">
                              <div className="succes-btn" style={{fontWeight:600}}>
                                  Back to Home                      
                              </div>
                          </Link>
                          <Link className="btn-text" to="/">
                              <div className="succes-btn" style={{fontWeight:600, backgroundColor: '#198754'}}>
                                  Home                      
                              </div>
                          </Link>
                      </div>
                  </div>
              </div>
          </div>
    </div>
  )
}

export default Succesfull